import { AppSubjectEnum } from '../../../shared/modules/authz/enums/app-subject.enum';
import { CaslSubject } from '../../../shared/modules/authz/decorators/casl-subject.decorator';
import { BaseDto } from '../../../shared/modules/base/dtos/base.dto';

/**
 * Agent category DTO for lists
 */
@CaslSubject(AppSubjectEnum.AGENT_CATEGORY)
export class AgentCategoryListDto extends BaseDto {
  name!: string;
  description?: string | null;
}
